import { PayloadAction } from '@reduxjs/toolkit';

interface RejectPayload {
  code: number;
  message: string;
  'message.tr': string;
}

export default (action: PayloadAction<unknown>): string => {
  const payload = action.payload as RejectPayload;
  if (!payload) {
    return 'common.error';
  }
  if (payload['message.tr']) {
    return payload['message.tr'];
  }
  return 'common.error';
};
